import { Injectable } from '@angular/core';
import { ColDef } from 'ag-grid-enterprise';
import { ModelLibrary } from 'src/app/shared/models/model-library';
import { CompoundRenderer } from 'src/app/shared/renderers/compound/compound.component';

@Injectable({
  providedIn: 'root',
})
export class EFSetupColDef {

  public getColumnsDefinition(cakeModels: ModelLibrary[], isProjectOwnershipValid: boolean): ColDef[] {
    return [
      {
        headerName: '',
        field: 'drag',
        rowDrag: true,
        width: 30,
        filter: 'agSetColumnFilter',
        editable: false,
      },
      {
        headerName: '',
        field: 'compoundOrder',
        hide: true,
        width: 0,
        filter: 'agSetColumnFilter',
        editable: false,
      },
      {
        headerName: 'Compound',
        field: 'metaboliteName',
        width: 350,
        cellRenderer: CompoundRenderer,
        cellRendererParams: {
          filter: false,
          disabled: !isProjectOwnershipValid,
          validateModel: false,
          compartment: ''
        },
        filter: 'agSetColumnFilter',
        wrapText: true,
        resizable: true,
        sortable: true,
        editable: false,
      },
      {
        headerName: 'Model',
        field: 'cake',
        width: 300,
        cellRenderer: 'listBoxRenderer',
        cellRendererParams: (params: any) => {
          return {
            options: cakeModels,
            optionValue: 'modelPk',
            optionLabel: 'nameVersion',
            checkbox: true,
            filter: false,
            multiple: true,
            disabled: !isProjectOwnershipValid || params.data.disabled,
            validateModel: true,
            compartment: 'cake'
          };
        },
        filter: 'agSetColumnFilter',
        wrapText: true,
        resizable: true,
        sortable: true,
        editable: false,
      }
    ];
  }
}
